import {
    checkAndUploadGeneralStatistic,
    QUESTION_CHANGE_QUESTION_DATA,
    QUESTION_DELETE,
    QUESTIONS_MASS_DELETE,
    QUESTION_SUCCESS_CREATE,
    QUESTIONS_STATUSES_CHANGE,
    PUT_QUESTIONS_TO_TRASH,
    TRASHED_QUESTIONS_RECOVER,
    IMPORT_QUESTIONS_SUCCESS
} from '../../modules/questions'


const questionsStatistic = store => next => action => {
    next(action)

    let {type, payload} = action

    switch (type) {
        case QUESTION_DELETE :
        case QUESTIONS_MASS_DELETE :
        case QUESTION_SUCCESS_CREATE :
        case QUESTIONS_STATUSES_CHANGE :
        case PUT_QUESTIONS_TO_TRASH :
        case TRASHED_QUESTIONS_RECOVER :
        case IMPORT_QUESTIONS_SUCCESS: {
            next(checkAndUploadGeneralStatistic(true))
            break
        }
        case QUESTION_CHANGE_QUESTION_DATA : {
            const {questionData = []} = payload
            let needUpdate
            questionData.forEach(qd => {
                const {key} = qd
                if (key === "status") needUpdate = true
            })
            if (needUpdate) next(checkAndUploadGeneralStatistic(true))

            break
        }
    }
}

export default questionsStatistic


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/middlewares/questionsStatistic.js